import dayjs from "dayjs";

export const fmtDate = (d) => !d ? "—" : (dayjs(d).isValid() ? dayjs(d).format("DD/MM/YYYY HH:mm:ss") : "—");
export const fmtShort = (d) => !d ? "—" : (dayjs(d).isValid() ? dayjs(d).format("DD/MM HH:mm") : "—");
export function fmtBattery(b) {
  if (b == null || b === "-" || isNaN(Number(b))) {
    return "—";
  }
  return `${Number(b)}%`;
}
export const fmtCoords = (lat, lng) => {
  const a = Number(lat), b = Number(lng);
  return (Number.isFinite(a) && Number.isFinite(b)) ? `${a.toFixed(6)}, ${b.toFixed(6)}` : "—";
};
export const isNum = (v) => Number.isFinite(Number(v));

// números / ids
export const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};
export const isValidId = (v) => {
  const n = Number(v);
  return Number.isInteger(n) && n > 0;
};

// strings
export const safeLower = (x) => (typeof x === "string" ? x.trim().toLowerCase() : null);

// roles
const ROLE_LABELS = { ADMIN: "ADMIN", SUPERVISOR: "SUPERVISOR", OPERATOR: "OPERARIO" };
export function pickRole(u = {}) {
  let raw =
    u.role ??
    u.rol ??
    u.type ??
    u.userRole ??
    u.roleName ??
    u.tipo ??
    u.typeUser ??
    u.user_type ??
    null;

  if (raw && typeof raw === "object") {
    raw = raw.name ?? raw.code ?? raw.key ?? raw.value ?? null;
  }

  if (raw == null && Number.isFinite(Number(u?.roleId))) {
    const id = Number(u.roleId);
    if (id === 1) raw = "ADMIN";
    else if (id === 2) raw = "SUPERVISOR";
    else if (id === 3) raw = "OPERATOR";
  }

  const norm = raw ? String(raw).trim().toUpperCase() : null;
  return ROLE_LABELS[norm ?? ""] ?? (norm ?? "—");
}

// normalizadores
export function normUser(u = {}) {
  const firstName = u.firstName ?? "";
  const lastName = u.lastName ?? "";
  const fallbackName = `${firstName} ${lastName}`.trim();
  const name = u.name ?? fallbackName;

  const companyObj = u.company ?? null;
  const companyId =
    (companyObj && toNum(companyObj.id)) ??
    toNum(u.companyId) ??
    toNum(u.company_id);

  return {
    id: u.id,
    name: name && name.length > 0 ? name : "—",
    dni: u.dni ?? u.identification ?? u.documentId ?? "—",
    role: pickRole(u),
    email: u.email ?? u.mail ?? null,
    companyId,
  };
}

export function normLockFromList(p = {}) {
  return {
    id: p.id,
    name: p.name ?? "—",
    serialNumber: p.serialNumber ?? p.serial ?? p.sn ?? null,
  };
}

export function normLockDetail(p = {}) {
  const companyObj = p.company ?? null;
  const companyId =
    (companyObj && toNum(companyObj.id)) ??
    toNum(p.companyId) ??
    toNum(p.company_id);

  const lastTelemetrySync = p.lastTelemetry ? p.lastTelemetry.lastSyncAt : null;
  const lastLocationAt = p.lastLocation ? p.lastLocation.eventAt : null;
  const updatedAt = p.updatedAt ?? p.updated ?? null;

  return {
    id: p.id,
    name: p.name ?? "—",
    serialNumber: p.serialNumber ?? null,
    companyId,
    permissions: Array.isArray(p.permissions) ? p.permissions : [],
    lastUpdatedAt: lastTelemetrySync ?? lastLocationAt ?? updatedAt ?? null,
  };
}

// matching permiso ↔ usuario
export function permMatchesUser(perm = {}, user = {}) {
  const pid = perm.userId ?? perm.usuarioId ?? (perm.user && perm.user.id) ?? null;

  const uEmail = safeLower(user.email ?? user.mail ?? null);
  const pEmail = safeLower(perm.userEmail ?? perm.email ?? (perm.user && perm.user.email) ?? null);

  const uDni = safeLower(user.dni ?? user.identification ?? user.documentId ?? null);
  const pDni = safeLower(perm.userDni ?? perm.dni ?? (perm.user && perm.user.dni) ?? null);

  if (isValidId(pid) && isValidId(user.id) && Number(pid) === Number(user.id)) return true;
  if (uEmail && pEmail && uEmail === pEmail) return true;
  if (uDni && pDni && uDni === pDni) return true;
  return false;
}

// util: ejecutar en lotes (limita concurrencia)
export async function mapInBatches(items, batchSize, mapper) {
  const out = [];
  for (let i = 0; i < items.length; i += batchSize) {
    const slice = items.slice(i, i + batchSize);
    // eslint-disable-next-line no-await-in-loop
    const res = await Promise.all(slice.map(mapper));
    out.push(...res);
  }
  return out;
}